export const PRIVATE_SHARE = 'private' as const;
export const OPEN_SHARE = 'loggedin' as const;

// for server-side errors
export const ENTITY_NAME_FIELD_NAME = 'name' as const;
export const ENTITY_DESCRIPTION_FIELD_NAME = 'description' as const;
export const SHARE_PERMISSIONS_FIELD_NAME = 'sharePermissions' as const;
export const EDIT_PERMISSIONS_FIELD_NAME = 'editPermissions' as const;
